// extracted by mini-css-extract-plugin
module.exports = {"postedBy":"e_Ai","postedByDate":"e_Bi","mobileView":"e_Ci"};